import Footer from '../features/footer/footer';
import Header from '../features/headers/header';
import Privacy from '../features/legal/layouts/privacy';
import { MAIN_CONTENT_ID } from '../global/config/layout';

export default function PrivacyPage() {
    return (
        <>
            <Header />
            <main id={MAIN_CONTENT_ID} className="app-shell__main" tabIndex={-1}>
                <Privacy />
            </main>
            <Footer />
        </>
    );
}
